import { render, staticRenderFns } from "./V2ProductInventory.vue?vue&type=template&id=1820a480&scoped=true&"
import script from "./V2ProductInventory.vue?vue&type=script&lang=js&"
export * from "./V2ProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductInventory.vue?vue&type=style&index=0&id=1820a480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820a480",
  null
  
)

export default component.exports